import React from 'react';

function ResendMifs() {
  return <div>ResendMifs</div>;
}

export default ResendMifs;
